exports.components = {
  "component---src-pages-assets-jsx": () => import("./../../../src/pages/assets.jsx" /* webpackChunkName: "component---src-pages-assets-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

